import React, { useState } from 'react';
import { FiLink } from 'react-icons/fi';

function CopyLinkButton({ sectionId, subsectionId = null }) {
  const [isAnimating, setIsAnimating] = useState(false);
  
  const handleCopyLink = () => {
    // Construct the URL
    const baseUrl = window.location.origin + window.location.pathname;
    let hash;
    
    if (subsectionId) {
      hash = `#s=${sectionId}&ss=${subsectionId}`;
    } else {
      hash = `#s=${sectionId}`;
    }
    
    const fullUrl = baseUrl + hash;
    
    // Copy to clipboard
    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        // Show animation
        setIsAnimating(true);
        setTimeout(() => setIsAnimating(false), 1500);
      })
      .catch(err => {
        console.error('Failed to copy link: ', err);
      });
  };
  
  return (
    <button
      className={`copy-link-button ${isAnimating ? 'animate' : ''}`}
      onClick={handleCopyLink}
      aria-label="Copy link to this section"
      title="Copy link to clipboard"
    >
      <FiLink size={16} />
    </button>
  );
}

export default CopyLinkButton;